'use client'

import { Pagination } from '@/General/Pagination'
import { usePathname, useSearchParams } from 'next/navigation'

export const ClientPagination = ({
  totalCount,
  currentPage,
  perPage,
  hasPreviousPage,
  hasNextPage,
  scrollToId,
  onPageChange,
}: ClientPaginationProps) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const linkGenerator = (page: number) => {
    const params = new URLSearchParams(searchParams.toString())
    params.set('page', page.toString())

    return `${pathname}?${params.toString()}`
  }

  const handlePageChange = (page: number) => {
    if (onPageChange) {
      onPageChange(page)
    }
  }

  return (
    <Pagination
      totalCount={totalCount}
      page={currentPage}
      perPage={perPage}
      hasPreviousPage={hasPreviousPage}
      hasNextPage={hasNextPage}
      linkGenerator={linkGenerator}
      scrollToId={scrollToId}
      onPageChange={handlePageChange}
    />
  )
}

interface ClientPaginationProps {
  totalCount?: number
  currentPage: number
  perPage: number
  hasPreviousPage: boolean
  hasNextPage: boolean
  scrollToId?: string
  onPageChange?: (page: number) => void
}
